import React from 'react';
import { useLanguage, t } from '../context/LanguageContext';

export default function Pagination({ page, totalPages, onPrev, onNext }) {
  const { lang } = useLanguage();
  if (totalPages <= 1) return null;
  return (
    <div className="d-flex justify-content-between align-items-center my-3">
      <button className="btn btn-secondary" onClick={onPrev} disabled={page === 1}>&laquo; {t('Previous', 'Anterior', lang)}</button>
      <span>{t('Page', 'Página', lang)} {page} {t('of', 'de', lang)} {totalPages}</span>
      <button className="btn btn-secondary" onClick={onNext} disabled={page >= totalPages}>{t('Next', 'Siguiente', lang)} &raquo;</button>
    </div>
  );
}